import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=4f0cec3e&scoped=true&"
import script from "./ui-button.vue?vue&type=script&lang=js&"
export * from "./ui-button.vue?vue&type=script&lang=js&"
import style0 from "./ui-button.vue?vue&type=style&index=0&id=4f0cec3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0cec3e",
  null
  
)

export default component.exports